﻿import './tracker.config';

import TKModuleFactory from '@tk/utilities/tk.module.factory';
import { headerComponents } from './header';
import TKManager from '@tk/basics/tk.manager';
import TKFormElement from '@tk/controls/tk.form.element';
import TKFormValidator from '@tk/controls/tk.form.validator';
import TKFormZipCity from '@tk/controls/tk.form.zipcity';
import TKTabsAccordion from '@tk/controls/tk.tabs.accordion';
import TKDialog from '@tk/components/tk.dialog';
import TKStatusConsole from '@tk/components/tk.status.console';
import TKClipboard from '@tk/components/tk.clipboard';
import TKContextMenu from '@tk/components/tk.context.menu';
import TKTracker from '@tk/components/tracker/tk.tracker';
import TKTracking from '@tk/components/tracker/tk.tracking';
import TKStaticContent from '@tk/controls/tk.static.content';

import '@scss/modules/verification.scss';

export default class Verification extends TKModuleFactory {
    constructor() {
        super([
            ...headerComponents,
            { name: 'tk-manager', constructor: TKManager },
            { name: 'tk-tracker', constructor: TKTracker },
            { name: 'tk-status-console', constructor: TKStatusConsole },
            { name: 'tk-clipboard', constructor: TKClipboard },
            { name: 'tk-form-zip-city', constructor: TKFormZipCity },
            { name: 'tk-form-element', constructor: TKFormElement },
            { name: 'tk-form-validator', constructor: TKFormValidator },
            { name: 'tk-tabs-accordion', constructor: TKTabsAccordion },
            { name: 'tk-dialog', constructor: TKDialog },
            { name: 'tk-context-menu', constructor: TKContextMenu },
            { name: 'tk-tracking', constructor: TKTracking },
            { name: 'tk-static-content', constructor: TKStaticContent },
        ]);
    }
}

new Verification();
